<script lang="ts">
  import { fmtDeltaPct } from '../lib/format';

  let {
    eyebrow,
    value,
    valueSub,
    deltaPct,
    deltaSuffix = '/ 30д',
    invertDelta = false,
    spark,
  }: {
    eyebrow: string;
    value: string;
    valueSub?: string;
    deltaPct?: number | null;
    deltaSuffix?: string;
    invertDelta?: boolean;
    spark?: number[]; // 8 values, relative height
  } = $props();

  const delta = $derived(deltaPct != null ? fmtDeltaPct(deltaPct) : null);
  const showPositive = $derived(
    delta ? (invertDelta ? !delta.isPositive : delta.isPositive) : false,
  );
  const sparkMax = $derived(spark && spark.length > 0 ? Math.max(...spark, 1) : 1);
</script>

<div class="group rounded-2xl border border-[var(--color-border-2)] bg-[var(--color-surface)] p-4 pb-3.5 relative overflow-hidden shadow-card transition-[transform,box-shadow] duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-px hover:shadow-pop">
  <div class="text-[9.5px] font-semibold uppercase tracking-[1.2px] text-[var(--color-text-muted-2)] mb-1.5">
    {eyebrow}
  </div>
  <div class="text-[20px] sm:text-[24px] font-semibold leading-none tracking-[-0.02em] tabular-nums">
    {value}{#if valueSub}<span class="text-[11px] font-medium text-[var(--color-text-muted)] ml-0.5">{valueSub}</span>{/if}
  </div>

  {#if delta}
    <span
      class="inline-flex items-center gap-1 mt-1.5 rounded-full px-2 py-0.5 text-[10.5px] font-bold {showPositive
        ? 'bg-emerald-100 text-emerald-700'
        : 'bg-red-100 text-red-700'}"
    >
      {delta.text} {deltaSuffix}
    </span>
  {/if}

  {#if spark && spark.length > 0}
    <div class="mt-2 flex h-6 items-end gap-0.5">
      {#each spark as h, i (i)}
        <div
          class="flex-1 rounded-[1px]"
          class:last={i === spark.length - 1}
          style="height: {Math.max(8, (h / sparkMax) * 100)}%; background: linear-gradient(180deg, var(--color-pu-2), var(--color-pu)); opacity: {i === spark.length - 1 ? 1 : 0.5};"
        ></div>
      {/each}
    </div>
  {/if}
</div>
